import { useEffect, useState } from "react";

// Must match the `md` breakpoint in tailwind.config.ts
export const MOBILE_BREAKPOINT = 768;

// "Pad" width: below this the app is still in its desktop 3-column layout, but
// a right-side panel (e.g. the note inspector) would crowd the editor, so those
// features present as a bottom sheet instead. Not the global mobile switch.
export const PAD_BREAKPOINT = 1200;

/** True when the device is a phone/tablet — survives landscape orientation. */
const isMobileBrowser =
  typeof navigator !== "undefined" &&
  (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 0 && /Macintosh/i.test(navigator.userAgent)));

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(
    () => isMobileBrowser || window.innerWidth < breakpoint,
  );

  useEffect(() => {
    if (isMobileBrowser) return; // always true, no need to listen
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", handler);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", handler);
  }, [breakpoint]);

  return isMobile;
}
